import { Injectable } from '@angular/core';
import { User } from '@app/users/user.interface';
import { WsService, UsersService } from '@app/shared';
import { forkJoin } from 'rxjs/observable/forkJoin';
import 'rxjs/add/operator/mergeMap';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { NotificationService } from '@app/shared/services/notification.service';
import { map } from 'rxjs/operator/map';

@Injectable()
export class UsersDataService {
  users: Array<User>;
  roles = [];
  services = [];
  filteringData;
  editUsers;
  private lengthSource = new BehaviorSubject(200);
  taskCount = this.lengthSource.asObservable();
  dataLength: number;
  soureceData;


  constructor(
    private userService: UsersService,
    private translate: TranslateService,
    private notification: NotificationService
  ) {}

  updateLength (length: number) {
    this.lengthSource.next(length);
  }

  emmitEditUser(user, id) {
  if (!this.filteringData.length) {
    this.users = this.users.map(el => {
      if (el.id === id ){
        return {...user, ...{password: '', id: id, confirmPassword: '', created_at: new Date()}};
      } else return el;
    });
  } else {
    this.users = this.filteringData.map(el => {
      if (el.id === id ){
        return {...user, ...{password: '', id: id, confirmPassword: '', created_at: new Date()}};
      } else return el;
    });
    this.filteringData = Object.assign(this.users);
    }
  }
  emmitCreateUser(user, dataId) {
    this.users.unshift({...user, ...{id: dataId, confirmPassword: '', password: '', created_at: new Date()}});
    this.users = this.users.map(el => el);
    this.filteringData = this.users.filter(el=>el);
    this.updateLength(this.dataLength +=1);
  }
  emmitDeleteUser(id) {
    this.users = this.users.filter(el=>el.id!==id);
    this.users = this.filteringData.filter(el=>el.id!==id);
    this.filteringData = this.users.filter(el=>el.id!==id);
    this.updateLength(this.dataLength -=1 );
  }

  getSearchUsersForName(searchUser) {
    this.users = this.filteringData.filter(user => user.name && user.name.toLowerCase().includes(searchUser.toLowerCase()));
  }

  getAllUsers () {
    return this.userService.getUsers();
  }
  getAllRoles() {
    return this.userService.getRolesList();
  }
  getAllServices() {
    return this.userService.getServicesList();
  }

  getUsersByScrooll(currentScroll, values = [838], currentRoles, type, sort) {
    this.userService.getUsers().subscribe(res => {
      this.users = res.data;
      this.filteringData = res.data;
      this.dataLength =  res.data.length;
      this.updateLength(this.dataLength);
      this.filteringData = [...this.emitSortUsers (sort, res.data).filter(el => {
        if (el.type === type) {
          return el;
        }
      }), ...this.emitSortUsers (sort, res.data).filter(el => {
        if (el.type !== type) {
          return el;
        }
      })];
      this.filteringData = this.filteringData.filter(user => {
        if((!values.length && !user.services.length)||((values.length === this.services.length) && !user.services.length)) {
          return user;
        }
        for (let service of user.services) {
          for (let value of values) {
            if (service === value) {
              return user;
            }

          }
        }
      }).filter(user => {
        if (!currentRoles) {
          return user;
        } else {
          for (let role of user.roles) {
            for (let currentRole of currentRoles) {
              if ( role === currentRole) {
                return user;
              }
            }
          }
        }
        if (!currentRoles.length && !user.roles.length) {
          return user;
        }
      });
      this.users = this.filteringData.slice(0, currentScroll);
      this.editUsers = Object.assign(this.users);
      // this.users = this.filteringData;
    });
  }
  // filteringOfType(type, users) {
  //   if (!type) {
  //     return users = users.map(el => el);
  //   }
  //   if (type === 'admin') {
  //     return users = users.map(el => el).sort(function(a, b) {
  //       return a.type === b.type ? 0 : (a.type || b.type) === type ? -1 : 1;
  //     });
  //   }
  //   if (type === 'operator') {
  //     return users = users.map(el => el).sort(function(a, b) {
  //       return a.type === b.type ? 0 : (a.type || b.type) === type ? -1 : 1;
  //     });
  //   }
  // }

  emitSortUsers (sort = {active: 'created_at', direction: 'desc'}, users) {
    const active = sort.active;
    if (!sort.direction ) {
      return users = users.map(el => el);
    }
    if (sort.active === 'created_at') {
      if ((sort.active) && (sort.direction === 'asc')) {
        return users = users.map(el => el).sort(function(a, b) {
           return dateSource(a[active]) - dateSource(b[active]);
        });
      } else if ((sort.active) && (sort.direction === 'desc')) {
        return users = users.map(el => el).sort(function(a, b) {
          return dateSource(b[active]) - dateSource(a[active]);
       });
      }
    } else {
      if ((sort.active) && (sort.direction === 'asc')) {
        return users = [...users.filter(el => !isNaN(el[active])).sort((a, b) => {
          return Number(a[active] - Number(b[active]));
        }), ...users.filter(el => isNaN(el[active])).sort()];


      } else if ((sort.active) && (sort.direction === 'desc')) {
        return users = [...users.filter(el => isNaN(el[active])).reverse(), ...users.filter(el => !isNaN(el[active])).sort((a, b) => {
          return Number(b[active] - Number(a[active]));
        })];

      }
    }

    function dateSource(val) {
      const dateValue = new Date(val);
      return Number(dateValue);
    }
}

  createUser(user: User) {
    return this.userService.addUser({
      name: user.name,
      password: user.password,
      type: user.type
    }).catch(err => Observable.of(err))
      .flatMap((res) => {
        if (res.error || [...user.roles, ...user.services].length == 0) return Observable.of(res);
        const requests = [
          Observable.of(res),
          this.userService.addRoles(res.data.id, user.roles),
          forkJoin(user.services.map(service => this.userService.addService(res.data.id, service)))
        ]
        return forkJoin(
          ...requests.filter((request: any) => request)).catch(err => Observable.of(err))
      });
  }

  editUser(user, roles, services, id) {
    let userObj: any = {
      id: id,
      name: user.name,
      type: user.type
    };
    if (user.password) userObj.password = user.password;
    const requests = [
      this.userService.editUser(userObj),
      this.userService.addRoles(id, roles.add),
      this.userService.removeRoles(id, roles.remove),
      forkJoin(services.add.map(service => this.userService.addService(id, service))),
      forkJoin(services.remove.map(service => this.userService.removeService(id, service)))
    ]

    return forkJoin(
      ...requests.filter((request: any) => !!request && (request.source || request.sources))
    ).catch(err => Observable.of(err));
  }

  deleteUser(id) {
    return this.userService.deleteUser(id).catch(err => Observable.of(err));
  }

  loadUserFormdData() {
    if (this.roles.length == 0) {
      this.userService.getRolesList().subscribe(res => {
        this.roles = res.data;
      });
    }
    if (this.services.length == 0) {
      this.userService.getServicesList().subscribe(res => {
        this.services = res.data;
      });
    }
  }

  getService(id) {
    let obj = this.services.filter(service => service.id == id)[0];
    if (!obj) {
      return { name: 'NOT FOUND SERVICE' };
    }
    return {
      name: obj.name,
      city: obj.city ? obj.city.name : ''
    };
  }

  getRole(id) {
    return this.roles.filter(role => id == role.id)[0];
  }

}



// WEBPACK FOOTER //
// ./src/app/users/users-data.service.ts